import request from "@/request";

export type User = {
  cusId: string;
  name: string;
  email: string;
  phone: string;
};

export interface SocketTicket {
  ticket?: string;
}

export interface UrlParams {
  group_id?: string;
  web_plugin_id?: string;
  // 当前使用渠道
  channel?: string;
}

export interface LoginInfo {
  accessToken: string;
  accessTokenExpiresIn: string;
  cusInfo: User;
  refreshToken: string;
  refreshTokenExpiresIn: string;
}

export const login = (ticket: string) => {
  return request.post<LoginInfo>("/cus/auth/ticket/login", {
    ticket,
  });
};

export const loginByBBLToken = (accessToken: string) => {
  return request.post<LoginInfo>("/cus/auth/bbl-token/login", undefined, {
    headers: {
      bbl_token: `Bearer ${accessToken}`,
    },
  });
};

// export const getUserInfo = () => {
//   return request.get<User>("/cus/auth/cusInfo");
// };

export const getSocketTicket = () => {
  return request.get<SocketTicket>("/cus/auth/ws/ticket");
};

export const refreshTokenData = (refreshToken: string) => {
  return request.post<LoginInfo>("/cus/auth/token/refresh", {
    refreshToken,
  });
};
